export const ORDER_STATUS_OPEN = 'open'
export const ORDER_STATUS_FINISHED = 'finished'
export const ORDER_STATUS_CANCELED = 'canceled'

export const ORDER_STATUSES = [
  { label: 'Em aberto', value: ORDER_STATUS_OPEN },
  { label: 'Fechado', value: ORDER_STATUS_FINISHED },
  { label: 'Cancelado', value: ORDER_STATUS_CANCELED },
]

export const ORDER_PAYMENT_STATUSES = [
  { label: 'Pago', value: true },
  { label: 'Pendente', value: false },
]
